import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpecialOperation = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 -3 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_134_98896)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 4,
				width: 40,
				height: 40,
				rx: 2,
				fill: "#F9F9FA"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M24.56 19.982C24.56 24.589 21.704 26.323 19.137 26.323C15.924 26.323 13.748 24.181 13.748 19.982C13.748 15.375 16.604 13.641 19.171 13.641C22.384 13.641 24.56 15.783 24.56 19.982ZM22.707 19.982C22.707 17.551 21.738 15.256 19.154 15.256C16.536 15.256 15.601 17.534 15.601 19.982C15.601 22.413 16.57 24.708 19.154 24.708C21.772 24.708 22.707 22.43 22.707 19.982ZM34.7198 17.636C34.7198 20.917 32.0678 21.563 29.8578 21.563H28.6168V26H26.7978V13.998H29.8238C32.3398 13.998 34.7198 14.661 34.7198 17.636ZM32.8838 17.738C32.8838 15.817 31.2348 15.545 29.9258 15.545H28.6168V20.016H29.8578C31.4388 20.016 32.8838 19.574 32.8838 17.738Z",
				fill: "#BE8484"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_134_98896",
			x: 0,
			y: 0,
			width: 48,
			height: 48,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_134_98896"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_134_98896",
					result: "shape"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgSpecialOperation);
export { ForwardRef as ReactComponent };
